<template>
  <div class="dose-page">
    <Top />

    <section class="hero">
        <img :src="bannerImage" :alt="bannerAlt" class="banner-img">
    </section>

    <section class="welcome">
      <div class="container section-inner">
        <h2 class="section-title">WELCOME TO DOSE</h2>
        <p class="section-desc">
          With over 10 years of nursing experience and more than four years dedicated to aesthetic medicine, Mor Haim brings a thoughtful and detail-oriented approach to every treatment.
Her work is rooted in both clinical expertise and a genuine passion for helping patients feel more confident in their own skin.
        </p>
        <div class="center">
          <button class="btn ghost" type="button" @click="goAbout">DISCOVER MORE</button>
        </div>
      </div>
    </section>

    <section class="treatments">
      <div class="container section-inner">
        <h2 class="section-title">OUR MOST LOVED TREATMENTS</h2>
        <div class="grid-cards">
          <article v-for="t in treatmentsDisplay" :key="t.rowKey" class="card treatment-card">
            <div class="thumb treatment-thumb">
              <img class="treat-img" :src="t.img" :alt="t.label" loading="lazy" />
            </div>
            <div class="treat-meta">
              <div class="treat-label">{{ t.label }}</div>
              <button class="btn treat-btn" type="button" @click="goTreatmentDetail(t)">LEARN MORE</button>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="doctors">
      <div class="container section-inner">
        <h2 class="section-title">SPECIALIST DOCTOR PROFILES</h2>
        <div class="section-mini">experienced, professional, reliable</div>
        <div class="profile-wrap">
          <div class="profile-card">
            <div class="profile-avatar">
              <img class="profile-photo" :src="doctor.photo" :alt="doctor.name" loading="lazy" />
            </div>
            <div class="profile-copy">
              <div class="profile-eyebrow">MEET</div>
              <h3 class="profile-name">{{ doctor.name }}</h3>
              <div class="profile-line" aria-hidden="true" />
              <div class="profile-quote" aria-hidden="true">“</div>
              <p class="profile-bio">{{ doctor.summary }}</p>
              <button class="btn primary profile-btn" type="button" @click="goAbout">{{ doctor.cta }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="news">
      <div class="container section-inner">
        <div class="news-head">
          <h2 class="news-head-title">What&apos;s New</h2>
          <p class="news-head-sub">Stay updated on our latest offers, events, and news.</p>
        </div>

        <div class="grid-news">
          <article
            v-for="n in newsDisplay"
            :key="n.rowKey"
            class="news-card"
            :class="{ 'is-clickable': n.detailId != null && n.detailId !== '' }"
            role="button"
            :tabindex="n.detailId != null && n.detailId !== '' ? 0 : -1"
            @click="goNewsDetail(n)"
            @keydown.enter.prevent="goNewsDetail(n)"
          >
            <div class="news-thumb">
              <img class="news-img" :src="n.img" :alt="n.title" loading="lazy" />
            </div>
            <div class="news-body">
              <h3 class="news-title">{{ n.title }}</h3>
              <p class="news-sub">{{ n.subtitle }}</p>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="cta-band">
      <div class="container cta-inner">
        <div class="cta-left">
          <h2 class="cta-title">AESTHETICS PRACTITIONER?</h2>
          <p class="cta-sub">
            Grow your business with DOSE and access new patients, forms, diary, reminders<br />
            and no show/late cancellation protection.
          </p>
        </div>
        <div class="cta-right">
          <button class="cta-btn" type="button" @click="goAbout">LEARN MORE</button>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Footer from '../components/footer.vue'
import Top from '../components/top.vue'
import { fetchPublicHomeBanner } from '../api/banner'
import { fetchHomeDoctors } from '../api/doctor'
import { fetchPublicNews } from '../api/news'
import { fetchPublicTreatments } from '../api/treatment'
import { resolveAssetUrl } from '../utils/asset'

export default {
  name: 'IndexPage',
  components: {
    Footer,
    Top,
  },
  data() {
    return {
      homeDoctorApi: null,
      /** null：接口失败或未请求完成前用静态降级；数组：接口结果（可为空） */
      homeTreatmentsFromApi: null,
      /** null：接口失败或未请求完成前用静态降级；数组：接口结果（可为空，首页仅展示前 3 条） */
      homeNewsFromApi: null,
      defaultTreatmentThumb: require('../assets/images/xiangmu01.jpg'),
      defaultNewsThumb: require('../assets/images/newImg.jpg'),
      /** null: use static fallback until API responds or on failure */
      homeBannerFromApi: null,
      bannerFallback: require('../assets/images/indexBanner.jpg'),
      heroButtons: [
        { text: 'BOOK NOW', variant: 'primary' },
        { text: 'VIEW TREATMENTS', variant: 'ghost' },
        { text: 'LEARN MORE', variant: 'ghost' },
      ],
      heroBadges: ['Hydration', 'Glow', 'Calm'],
      treatmentsFallback: [
        {
          rowKey: 'fb-xiangmu01',
          img: require('../assets/images/xiangmu01.jpg'),
          label: 'Botox_Article_Dose_Aesthetics',
          detailId: null,
        },
        {
          rowKey: 'fb-xiangmu02',
          img: require('../assets/images/xiangmu02.jpg'),
          label: 'cheek_filler_dose_aesthetics',
          detailId: null,
        },
        {
          rowKey: 'fb-xiangmu03',
          img: require('../assets/images/xiangmu03.jpg'),
          label: 'Dose_Aesthetics_Chin_Filler_Article-v2',
          detailId: null,
        },
        {
          rowKey: 'fb-xiangmu04',
          img: require('../assets/images/xiangmu04.jpg'),
          label: 'Dose_Aesthetics_Dysport_Guide',
          detailId: null,
        },
        {
          rowKey: 'fb-xiangmu05',
          img: require('../assets/images/xiangmu05.jpg'),
          label: 'dose_aesthetics_full_guide',
          detailId: null,
        },
        {
          rowKey: 'fb-xiangmu06',
          img: require('../assets/images/xiangmu06.jpg'),
          label: 'Botox_Article_Dose_Aesthetics',
          detailId: null,
        },
      ],
      doctorFallback: {
        name: 'MOR HAIM',
        photo: require('../assets/images/yisheng.jpg'),
        summary:
          'With over 10 years of nursing experience and more than four years dedicated to aesthetic medicine, Mor Haim brings a thoughtful and detail-oriented approach to every treatment. Her work is rooted in both clinical expertise and a genuine passion for helping patients feel more confident in their own skin.',
        cta: 'LEARN MORE',
      },
      newsItemsFallback: [
        {
          title: 'New Regulation for Home Beauty Devices',
          subtitle:
            'In 2026, mild skincare ingredients such as Zinc PCA and papain have become trending formulas. Brands focus on oil control, soothing and gentle exfoliation. ',
          img: require('../assets/images/newImg.jpg'),
        },
        {
          title: 'New Regulation for Home Beauty Devices',
          subtitle:
            'In 2026, mild skincare ingredients such as Zinc PCA and papain have become trending formulas. Brands focus on oil control, soothing and gentle exfoliation. ',
          img: require('../assets/images/newImg.jpg'),
        },
        {
          title: 'New Regulation for Home Beauty Devices',
          subtitle:
            'In 2026, mild skincare ingredients such as Zinc PCA and papain have become trending formulas. Brands focus on oil control, soothing and gentle exfoliation. ',
          img: require('../assets/images/newImg.jpg'),
        },
      ],
    }
  },
  computed: {
    bannerImage() {
      if (this.homeBannerFromApi != null) {
        const url = resolveAssetUrl(
          this.homeBannerFromApi.imageUrl || this.homeBannerFromApi.image_url
        )
        if (url) return url
      }
      return this.bannerFallback
    },
    bannerAlt() {
      if (this.homeBannerFromApi != null) {
        const alt = (
          this.homeBannerFromApi.altText ||
          this.homeBannerFromApi.alt_text ||
          this.homeBannerFromApi.title ||
          ''
        ).trim()
        if (alt) return alt
      }
      return 'Home banner'
    },
    /** 来自 GET /web/doctor/public/home（仅 status=1 且 show_on_home=1，按排序取第一条） */
    doctor() {
      const row = this.homeDoctorApi
      if (!row) return this.doctorFallback
      const photo = resolveAssetUrl(row.avatarUrl) || this.doctorFallback.photo
      const summaryText = (row.summary && String(row.summary).trim()) || ''
      return {
        name: (row.name && String(row.name).trim()) || this.doctorFallback.name,
        photo,
        summary: summaryText || this.doctorFallback.bio,
        cta: this.doctorFallback.cta,
      }
    },
    treatmentsDisplay() {
      if (this.homeTreatmentsFromApi != null) {
        return (this.homeTreatmentsFromApi || []).map((row) => ({
          rowKey: 'api-' + row.id,
          img: this.treatmentCardImage(row),
          label: (row.title && String(row.title).trim()) || '',
          detailId: row.id,
        }))
      }
      return this.treatmentsFallback
    },
    /** 首页资讯区：优先 GET /web/news/public/list 前 3 条；失败时静态降级 */
    newsDisplay() {
      if (this.homeNewsFromApi != null) {
        return (this.homeNewsFromApi || []).slice(0, 3).map((row) => ({
          rowKey: 'api-news-' + row.id,
          detailId: row.id,
          title: (row.title && String(row.title).trim()) || '',
          subtitle: this.newsExcerpt(row),
          img: this.newsCardImage(row),
        }))
      }
      return this.newsItemsFallback.map((n, idx) => ({
        rowKey: 'fb-news-' + idx,
        detailId: null,
        title: n.title,
        subtitle: n.subtitle,
        img: n.img,
      }))
    },
  },
  mounted() {
    fetchPublicHomeBanner()
      .then((data) => {
        this.homeBannerFromApi = data || {}
      })
      .catch(() => {
        this.homeBannerFromApi = null
      })
    fetchHomeDoctors()
      .then((list) => {
        if (list && list.length) this.homeDoctorApi = list[0]
      })
      .catch(() => {})
    fetchPublicTreatments()
      .then((list) => {
        this.homeTreatmentsFromApi = list || []
      })
      .catch(() => {
        this.homeTreatmentsFromApi = null
      })
    fetchPublicNews()
      .then((list) => {
        this.homeNewsFromApi = list || []
      })
      .catch(() => {
        this.homeNewsFromApi = null
      })
  },
  methods: {
    goAbout() {
      this.$router.push({ name: 'about' }).catch((err) => {
        if (err && err.name !== 'NavigationDuplicated') throw err
      })
    },
    treatmentCardImage(row) {
      const url = row.coverImageUrl || row.cover_image_url
      const resolved = resolveAssetUrl(url)
      return resolved || this.defaultTreatmentThumb
    },
    newsCardImage(row) {
      const url = row.coverImageUrl || row.cover_image_url
      const resolved = resolveAssetUrl(url)
      return resolved || this.defaultNewsThumb
    },
    newsExcerpt(row) {
      const raw = row.content
      if (raw != null && String(raw).trim()) {
        const text = String(raw)
          .replace(/<[^>]*>/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
        const max = 220
        if (text.length <= max) return text
        return text.slice(0, max) + '…'
      }
      const pub = row.publisher != null ? String(row.publisher).trim() : ''
      return pub
    },
    goTreatmentDetail(t) {
      if (t.detailId != null && t.detailId !== '') {
        this.$router.push({ name: 'treatmentDetail', params: { id: String(t.detailId) } }).catch((err) => {
          if (err && err.name !== 'NavigationDuplicated') throw err
        })
        return
      }
      this.$router.push({ name: 'treatments' }).catch((err) => {
        if (err && err.name !== 'NavigationDuplicated') throw err
      })
    },
    goNewsDetail(n) {
      if (n.detailId != null && n.detailId !== '') {
        this.$router.push({ name: 'newsDetail', params: { id: String(n.detailId) } }).catch((err) => {
          if (err && err.name !== 'NavigationDuplicated') throw err
        })
      }
    },
  },
}
</script>

<style scoped>
.dose-page {
  min-height: 100vh;
  background: #ffffff;
  color: #0c0b06;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.topbar-inner {
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nav-toggle {
  display: none;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #0c0b06;
}

.nav-toggle-icon {
  width: 18px;
  height: 2px;
  background: currentColor;
  display: inline-block;
  position: relative;
}

.nav-toggle-icon::before,
.nav-toggle-icon::after {
  content: '';
  position: absolute;
  left: 0;
  width: 18px;
  height: 2px;
  background: currentColor;
}

.nav-toggle-icon::before {
  top: -6px;
}

.nav-toggle-icon::after {
  top: 6px;
}

.drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 40;
}

.mobile-drawer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: min(320px, 86vw);
  background: #fff;
  z-index: 50;
  transform: translateX(-100%);
  transition: transform 200ms ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
}

.mobile-drawer.open {
  transform: translateX(0);
}

.drawer-head {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.drawer-close {
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  color: #0c0b06;
}

.drawer-nav {
  padding: 12px 0;
  overflow: auto;
}

.drawer-link {
  display: flex;
  align-items: center;
  height: 46px;
  padding: 0 18px;
  text-decoration: none;
  color:#0c0b06;
  font-size: 12px;
  letter-spacing: 0.08em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.drawer-link:active {
  background: rgba(0, 0, 0, 0.03);
}

.brand {
  display: flex;
  align-items: center;
  gap: 0;
  flex: 0 0 auto;
}

.brand-logo {
  height: 46px;
  width: auto;
  max-width: 220px;
  object-fit: contain;
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-name {
  font-weight: 700;
  letter-spacing: 0.06em;
}

.brand-tag {
  font-size: 12px;
  color: #0c0b06;
}

.nav {
  flex: 1;
  display: flex;
  gap: 34px;
  flex-wrap: nowrap;
  justify-content: center;
}

.nav-link {
  text-decoration: none;
  color: #0c0b06;
  font-size: 11px;
  letter-spacing: 0.08em;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.nav-label {
  font-weight: 500;
}

.nav-caret {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid rgba(0, 0, 0, 0.5);
  margin-left: 8px;
  transform: translateY(1px);
}

.topbar-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.phone {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #0c0b06;
  font-size: 12px;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.phone-icon {
  color: rgba(0, 0, 0, 0.55);
  display: inline-flex;
  align-items: center;
}

.phone:hover {
  color: #0c0b06;
}

.hero {
  background: linear-gradient(180deg, #fbfaf7 0%, #f4efe6 100%);
  padding: 0;
}

.banner-img {
  width: 100%;
  height: auto;
  display: block;
}

.hero-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
}

.hero-copy {
  flex: 1;
  min-width: 320px;
}

.hero-kicker {
  font-size: 12px;
  letter-spacing: 0.18em;
  color:#0c0b06;
  margin-bottom: 14px;
}

.hero-title {
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-weight: 600;
  letter-spacing: 0.02em;
  font-size: clamp(42px, 5vw, 72px);
  margin: 0 0 12px;
}

.hero-sub {
  font-size: clamp(16px, 1.6vw, 20px);
  color: #0c0b06;
  margin: 0 0 26px;
}

.hero-actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.btn {
  height: 36px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: transparent;
  font-size: 13px;
  letter-spacing: 0.06em;
  cursor: pointer;
}

.btn.primary {
  border-color: rgba(176, 138, 74, 0.55);
  background: rgba(176, 138, 74, 0.15);
  color: rgba(124, 84, 25, 0.98);
}

.btn.ghost {
  background: rgba(255, 255, 255, 0.5);
}
.btn.ghost:hover{
  background: #b08a4a;
  color:#fff
}

.hero-note {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #0c0b06;
  font-size: 13px;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #b08a4a;
  box-shadow: 0 0 0 5px rgba(176, 138, 74, 0.12);
}

.hero-art {
  width: min(520px, 44vw);
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.product-mock {
  width: 100%;
  height: 330px;
  border-radius: 24px;
  background: radial-gradient(circle at 50% 30%, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0) 55%),
    linear-gradient(135deg, #f6f0e6, #eadcc5);
  position: relative;
  overflow: hidden;
}

.product {
  position: absolute;
  bottom: 22px;
  width: 120px;
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.55);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
}

.product-1 {
  left: 70px;
  height: 240px;
}
.product-2 {
  left: 200px;
  height: 280px;
}
.product-3 {
  left: 315px;
  height: 210px;
}

.product::before {
  content: '';
  position: absolute;
  inset: 14px 20px auto 20px;
  height: 58px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(176, 138, 74, 0.22), rgba(176, 138, 74, 0.04));
}

.hero-badges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.mini-pill {
  padding: 9px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 12px;
  color: #0c0b06;
}

.section-inner {
  padding: 40px 0;
}

@media (min-width: 1248px) {
  .welcome .container {
    width: 1200px;
    max-width: 1200px;
  }
}

.section-title {
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji';
  font-weight: 500;
  letter-spacing: 0.08em;
  font-size: clamp(26px, 3vw, 40px);
  margin: 0;
  text-align: center;
}

.section-desc {
  text-align: center;
  max-width: 720px;
  margin: 18px auto 0;
  color: #0c0b06;
  font-size: 14px;
  line-height: 1.8;
}
.center {
  display: flex;
  justify-content: center;
  margin-top: 26px;
}

.btn.ghost {
  color: #0c0b06;
}

.grid-cards {
  margin-top: 34px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.card {
  border-radius: 0;
  overflow: hidden;
  background: transparent;
  border: none;
}

.thumb {
  position: relative;
}

.treatment-thumb {
  background: #f3f3f3;
  aspect-ratio: 4 / 3;
  overflow: hidden;
}

.treat-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform: scale(1.001);
  transition: transform 180ms ease;
}

.doctors {
  background: #f4f3ef;
}

.doctors .section-title {
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji';
  font-weight: 500;
  letter-spacing: 0.08em;
}

.section-mini {
  margin-top: 10px;
  text-align: center;
  font-size: 11px;
  letter-spacing: 0.06em;
  color: #0c0b06;
}

.treat-meta {
  padding: 16px 0 0;
  text-align: center;
}

.treat-label {
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #0c0b06;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.btn.treat-btn {
  height: 34px;
  min-width: 170px;
  padding: 0 22px;
  border-radius: 0;
  font-size: 10px;
  letter-spacing: 0.14em;
  border-color: rgba(0, 0, 0, 0.22);
  background: #fff;
  color: #0c0b06;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, filter 0.2s ease;
}

.treatment-card:hover .btn.treat-btn,
.btn.treat-btn:hover,
.btn.treat-btn:focus-visible {
  background: #b08a4a;
  border-color: #b08a4a;
  cursor: pointer;
  color: #fff;
  filter: brightness(0.98);
}

@media (hover: hover) and (pointer: fine) {
  .treatment-card:hover .treat-img {
    transform: scale(1.03);
    cursor: pointer;
  }
}

.profile-wrap {
  margin-top: 34px;
}

.profile-card {
  display: flex;
  gap: 28px;
  align-items: flex-start;
  justify-content: space-around;
  padding: 12px 0;
}

.profile-avatar {
  width: 360px;
  height: 360px;
  border-radius: 6px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
  flex: 0 0 auto;
}

.profile-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.profile-eyebrow {
  font-size: 12px;
  letter-spacing: 0.18em;
  color:#0c0b06;
}

.profile-name {
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
  font-size: 22px;
  margin: 8px 0 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.profile-line {
  height: 1px;
  background: rgba(0, 0, 0, 0.12);
  width: min(520px, 100%);
  margin: 12px 0 14px;
}

.profile-quote {
  font-size: 42px;
  line-height: 1;
  color: #0c0b06;
  margin: 0 0 6px;
}

.profile-bio {
  color: #0c0b06;
  line-height: 1.8;
  font-size: 13.5px;
  max-width: 560px;
}

.btn.primary.profile-btn {
  border-radius: 0;
  height: 38px;
  padding: 0 26px;
  font-size: 11px;
  letter-spacing: 0.14em;
  background: #b08a4a;
  border-color: #b08a4a;
  color: #fff;
  margin-top: 14px;
}

.news {
  background: #ffffff;
}

.news-head {
  text-align: center;
  padding: 18px 0 26px;
}

.news-head-title {
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji';
  font-weight: 500;
  letter-spacing: 0.08em;
  font-size: clamp(26px, 3vw, 40px);
  margin: 0;
  color: #0c0b06;
}

.news-head-sub {
  margin: 10px 0 0;
  font-size: 11px;
  color: #0c0b06;
  letter-spacing: 0.02em;
}

.grid-news {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 26px;
}

.news-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: none;
}

.news-card.is-clickable {
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

@media (hover: hover) and (pointer: fine) {
  .news-card.is-clickable:hover {
    border-color: rgba(176, 138, 74, 0.45);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  }

  .news-card.is-clickable:focus-visible {
    outline: 2px solid rgba(176, 138, 74, 0.65);
    outline-offset: 2px;
  }
}

.news-thumb {
  height: 150px;
  background: #f3f3f3;
  overflow: hidden;
}

.news-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.news-body {
  padding: 18px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.news-title {
  font-size: 12px;
  font-weight: 700;
  color: #0c0b06;
  margin: 0;
}

.news-sub {
  font-size: 11px;
  color: #0c0b06;
  line-height: 1.6;
  margin: 0;
}

.cta-band {
  padding: 44px 0;
  background: #f4f3ef;
}

.cta-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
}

.cta-title {
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
  font-size: 14px;
  margin: 0 0 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: #0c0b06;
}

.cta-sub {
  color: #0c0b06;
  line-height: 1.7;
  max-width: 620px;
  margin: 0;
  font-size: 12px;
}

.cta-btn {
  height: 36px;
  min-width: 150px;
  padding: 0 26px;
  border: none;
  border-radius: 0;
  background: #b08a4a;
  color: #fff;
  font-size: 11px;
  letter-spacing: 0.14em;
  cursor: pointer;
}

.cta-btn:hover {
  filter: brightness(0.96);
}

.footer {
  background: #0c0b06;
  color: #fff;
  padding: 60px 0  0 0px;
}

.footer-inner {
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr 1.1fr;
  gap: 26px;
}

.footer-brand {
  font-weight: 800;
  letter-spacing: 0.12em;
  margin-bottom: 10px;
}

.footer-desc {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
  font-size: 13px;
}

.footer-title {
  font-size: 12px;
  letter-spacing: 0.2em;
  margin-bottom: 12px;
  color: rgba(255, 255, 255, 0.85);
}

.footer-title.small {
  margin-bottom: 8px;
}

.footer-link {
  display: block;
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  margin-bottom: 10px;
  font-size: 13px;
}

.footer-link:hover {
  color: rgba(255, 255, 255, 0.95);
}

.footer-text {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 1.6;
}

.footer-bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding-top: 26px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  margin-top: 26px;
}

.footer-copy {
  color: rgba(255, 255, 255, 0.65);
  font-size: 13px;
}

.footer-hours {
  min-width: 220px;
}

@media (max-width: 1000px) {
  .hero-inner {
    gap: 28px;
  }
  .hero-art {
    width: min(460px, 48vw);
  }
  .grid-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .grid-news {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .footer-inner {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 720px) {
  .container {
    padding: 26px 12px;
  }

  .treat-label {
    font-size: 12px;
  }

  .topbar-inner {
    height: auto;
    padding: 14px 0;
    position: relative;
    justify-content: center;
    align-items: center;
  }
  .nav-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .brand {
    margin: 0 auto;
  }
  .topbar-right {
    display: none;
  }
  .nav {
    display: none;
  }
  .hero-inner {
    flex-direction: column;
    align-items: stretch;
  }
  .hero-art {
    width: 100%;
  }
  .product-mock {
    height: 260px;
  }
  .product {
    width: 92px;
    border-radius: 16px;
  }
  .product-1 {
    left: 26px;
    height: 210px;
  }
  .product-2 {
    left: 126px;
    height: 240px;
  }
  .product-3 {
    left: 222px;
    height: 185px;
  }

  .grid-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
  .grid-news {
    grid-template-columns: 1fr;
  }
  .profile-card {
    flex-direction: column;
    text-align: center;
  }
  .profile-avatar {
    width: min(360px, 100%);
    height: auto;
    aspect-ratio: 1 / 1;
  }
  .profile-line {
    margin-left: auto;
    margin-right: auto;
  }
  .btn.primary.profile-btn {
    align-self: center;
  }
  .cta-inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .cta-btn {
    width: 100%;
    max-width: 220px;
    align-self: flex-start;
  }
  .footer-bottom {
    flex-direction: column;
  }
}

</style>
